import React from 'react';
import { motion } from 'framer-motion';
import { Settings, Mail } from 'lucide-react';
export function Support() {
  return <section className="bg-gray-50 py-12" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center gap-4 text-center" data-id="element-139">
          <Settings className="w-12 h-12 text-emerald-600" data-id="element-140" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-141">Soporte Técnico</h3>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-142">
            <Mail className="w-5 h-5 text-emerald-600" data-id="element-143" />
            <a href="mailto:EbookDreamShop@gmail.com" className="hover:text-emerald-600 transition-colors font-medium" data-id="element-144">
              EbookDreamShop@gmail.com
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}